import React from 'react';
import { ChevronUpIcon, ShoppingBagIcon } from 'lucide-react';
const FREE_DELIVERY_THRESHOLD = 55;
interface NowStickyCartProps {
  itemCount: number;
  total: number;
  onViewCart: () => void;
}
export function NowStickyCart({
  itemCount,
  total,
  onViewCart
}: NowStickyCartProps) {
  const amountRemaining = Math.max(0, FREE_DELIVERY_THRESHOLD - total);
  const progress = Math.min(100, total / FREE_DELIVERY_THRESHOLD * 100);
  const itemLabel = itemCount === 1 ? 'item' : 'items';
  const deliveryMessage = amountRemaining > 0 ? `Add SAR ${amountRemaining.toFixed(0)} for free delivery` : 'You unlocked free delivery';
  return <aside className="fixed bottom-16 left-0 right-0 z-40 border-t border-brand-border bg-white/95 px-4 pb-3 pt-2 backdrop-blur-sm md:hidden" data-id="element-4676" data-mp="x5pc66ee3t5i">
      <div className="mb-2 rounded-lg bg-brand-light px-3 py-2" data-id="element-4677" data-mp="4nlf8pfmzyqw">
        <div className="flex items-center justify-between gap-2 text-xs font-semibold text-brand" data-id="element-4678" data-mp="4m0ict5uo3pv">
          <span data-id="element-4679" data-mp="k5lc0uycchw">{deliveryMessage}</span>
          <ChevronUpIcon className="h-4 w-4 flex-shrink-0" data-id="element-4680" data-mp="ec6e4yc9zo5d" />
        </div>
        <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-sage-light" aria-hidden="true" data-id="element-4681" data-mp="e9sian9ru7wr">
          <div className="h-full rounded-full bg-brand" style={{
          width: `${progress}%`
        }} data-id="element-4682" data-mp="j8daq0is7nan" />
        </div>
      </div>
      <button type="button" onClick={onViewCart} className="flex h-11 w-full items-center justify-between gap-3 rounded-lg bg-brand px-4 text-left text-white transition-colors duration-150 active:bg-brand-dark" aria-label={`View cart with ${itemCount} ${itemLabel}, total ${total.toFixed(2)} SAR`} data-id="element-4683" data-mp="t09jc5ihuvt4">
        <span className="flex min-w-0 items-center gap-2" data-id="element-4684" data-mp="5b85g2qw6sgg">
          <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-white/15" data-id="element-4685" data-mp="59nd8js1vllr"><ShoppingBagIcon className="h-4 w-4" data-id="element-4686" data-mp="abcp21n3k3aw" /></span>
          <span className="truncate text-sm font-semibold" data-id="element-4687" data-mp="1gqn6piq4w6hd">{itemCount} {itemLabel}</span>
          <span className="h-4 w-px bg-white/30" aria-hidden="true" data-id="element-4688" data-mp="1loygjtgfigzl" />
          <span className="text-sm font-bold" data-id="element-4689" data-mp="1lr1d6wc378da">SAR {total.toFixed(2)}</span>
        </span>
        <span className="flex-shrink-0 text-sm font-bold" data-id="element-4690" data-mp="3hufv00o5lxtj">View cart</span>
      </button>
    </aside>;
}